// extracted by mini-css-extract-plugin
export default {"fraudReportTable":"fraud-report-table-container__fraud-report-table___mm6o"};